import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

export const CampaignStrengthsRenderer = memo(({ value }) => (
  <Box
    sx={{
      width: '100%',
      p: '8px',
    }}
  >
    <Box
      sx={{
        color: 'text.main',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '400',
      }}
    >
      <Box
        as="span"
        sx={{
          margin: 0,
          width: '100%',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {value}
      </Box>
    </Box>
  </Box>
));

CampaignStrengthsRenderer.propTypes = {
  value: PropTypes.string.isRequired,
};
